import { environment } from '@web/config';

const APP_EVENT_DATA_LAYER = 'appEventDataLayer';
const ADOBE_LAUNCH_SCRIPT_ID = 'uhci-adobe-launch';

declare global {
  interface Window {
    appEventDataLayer?: unknown[];
  }
}

export function loadAdobeLaunch(): void {
  if (typeof document === 'undefined') {
    return;
  }

  const scriptUrl = environment.clickStreamUrl?.trim();

  if (!scriptUrl) {
    return;
  }

  window[APP_EVENT_DATA_LAYER] = window[APP_EVENT_DATA_LAYER] || [];

  if (document.getElementById(ADOBE_LAUNCH_SCRIPT_ID) || document.querySelector(`script[src="${scriptUrl}"]`)) {
    return;
  }

  const script = document.createElement('script');
  script.id = ADOBE_LAUNCH_SCRIPT_ID;
  script.type = 'text/javascript';
  script.async = true;
  script.src = scriptUrl;

  document.body.appendChild(script);
}